import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { PROVIDER_LOGIN_LANDING, isProviderLoginRole } from '../../utils/signedInLanding';

// A signed-in provider on the public provider landing goes home: the
// dashboard, whose journey card leads an unfinished provider to the right step.
export default function ProviderEntry({ children }) {
  const { auth, isAuthenticated, isLoading } = useAuth();
  if (isLoading) return <div role="status">Loading your account...</div>;
  if (isAuthenticated && isProviderLoginRole(auth?.user?.role)) {
    return <Navigate to={PROVIDER_LOGIN_LANDING} replace />;
  }
  return children;
}
